import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpUrlEncodingCodec } from '@angular/common/http';
import { Report } from '../_model/Report';
import { Observable, Subject } from 'rxjs';
import { environment } from '../../environments/environment';
import { TemplateModel } from '../_model/TemplateModel';
import { SourceInfo } from '../_model/SourceInfo';
import { Utils } from '../_util/utils';
import { Generator } from '../_model/Generator';
import { Logo } from '../_model/Logo';
import { PhotosInformation } from '../_model/PhotosInformation';
import { CookieService } from '../_services/cookie.service';
@Injectable({
  providedIn: 'root'
})
export class PdfService {
  public defaultLogo: Logo;
  public report: Report;
  public loading = false;
  public shapes: any[];
  public reports: Report[];
  public loadPreview = false;
  public progress = 0;
  public sources: SourceInfo[];
  public photos: PhotosInformation[];
  public currentPageIndex: number;
  public previewIndex: number;
  public previewCounter: number;
  public templateModel: TemplateModel;
  public dpi: number;
  public editNotify = new Subject<Report>();
  public photoLandscape = `<!DOCTYPE HTML><html><head> <style> * { padding: 0; margin: 0; box-sizing: border-box; } body { font-size: 12px; font-family: Arial, Helvetica, sans-serif; } .page-before { display: block; page-break-before: always; } .page-after { display: block; page-break-after: always; } @page landscape { size: 11in 8.5in; } .landscape { page: landscape; } .row { display: flex; justify-content: space-evenly; margin-bottom: 25px; overflow: visible; } .card { background-color: #fff; box-shadow: 0 2px 10px rgba(0, 0, 0, .15); } .card.spacer { background-color: transparent; box-shadow: none; } .card img { box-shadow: 0 2px 10px rgba(0, 0, 0, .15); width: 100%; } .card-body { text-align: center; display: flex; justify-content: space-between; padding-top: 8px; } .card-number { width: 1%; padding-left: 2px; } .text-muted { width: 99%; margin-left: 1.5em; } .landscape .gallery-2 .card { padding: 2px; flex: 0 45%; height: 646px; } .landscape .gallery-2 .card img { height: 452px; } .landscape .gallery-4 .card { padding: 2px; flex: 0 45%; height: 323px; } .landscape .gallery-4 .card img { height: 226px; } .landscape .gallery-6 .card { padding: 2px; flex: 0 30%; height: 323px; } .landscape .gallery-6 .card img { height: 226px; } </style></head><body>`;
  public photoPortrait = `<!DOCTYPE HTML><html><head> <style> * { padding: 0; margin: 0; box-sizing: border-box; } body { font-size: 12px; font-family: Arial, Helvetica, sans-serif; } .page-before { display: block; page-break-before: always; } .page-after { display: block; page-break-after: always; } @page portrait { size: 8.5in 11in; } .portrait { page: portrait; } .row { display: flex; justify-content: space-evenly; margin-bottom: 25px; overflow: visible; } .card { background-color: #fff; box-shadow: 0 2px 10px rgba(0, 0, 0, .15); } .card.spacer { background-color: transparent; box-shadow: none; } .card img { box-shadow: 0 2px 10px rgba(0, 0, 0, .15); } .card-body { text-align: center; display: flex; justify-content: space-between; padding-top: 8px; } .card-number { width: 1%; padding-left: 2px; } .text-muted { width: 99%; margin-right: 10px;}.card-img-top { width: 100%; } .portrait .gallery-2 .card { padding: 2px; flex: 0 100%; height: 410px; } .portrait .gallery-2 .card img { height: 375px; } .portrait .gallery-4 .card { padding: 2px; flex: 0 45%; height: 410px; } .portrait .gallery-4 .card img { display: block; height: 346px; } .portrait .gallery-6 .card { padding: 2px; flex: 0 45%; height: 260px; } .portrait .gallery-6 .card img { height: 212px; } </style></head><body>`;
  public tagEnd = '</body></html>';

  constructor(private http: HttpClient,private cookieService:CookieService) {
    this.shapes = [];
    this.sources = [];
    this.dpi = Utils.dpi();
  }

  generatePdf(htmlc: string, r: string, t: string, cid: string, psize: string, orient: string, pmargin: string, headerbase64: string, footerbase64: string, headerline: string, footerline: string): Observable<Generator> {
    console.log({ htmlc, r, t, cid, psize, orient, pmargin, headerbase64, footerbase64, headerline, footerline });

    return this.http.post<Generator>(`${environment.api.generatePdf}`, { htmlc, r, t, cid, psize, orient, pmargin, headerbase64, footerbase64, headerline, footerline }, {
      headers: new HttpHeaders({ 'Content-Type': 'application/json' }),
      responseType: 'json'
    });
  }

  univeralService(inputJson: any): Observable<any> {
    let sessid='';
    let info=this.cookieService.getCookie("userInfo");
    if(info&&JSON.parse(info).SESSION_ID){
     sessid=JSON.parse(this.cookieService.getCookie("userInfo")).SESSION_ID;
    }else{
      window.location.reload();
    }
    let orijson=JSON.parse(inputJson);
    orijson['SESSION_ID']=sessid;
    let data=JSON.stringify(orijson);
    return this.http.post<any>(`${environment.api.universalCall}`, data);
  }

  univeralService1(inputJson: any): Observable<any> {
    console.log(`${environment.api.universalCall}`);
    let sessid='';
    let info=this.cookieService.getCookie("userInfo");
    if(info&&JSON.parse(info).SESSION_ID){
     sessid=JSON.parse(this.cookieService.getCookie("userInfo")).SESSION_ID;
    }else{
      window.location.reload();
    }
    let orijson=JSON.parse(inputJson);
    orijson['SESSION_ID']=sessid;
    let data=JSON.stringify(orijson);
    return this.http.post<any>(`${environment.api.universalCall}`, data, { responseType: 'text' as 'json' });
  }

  uploadFile2(inputJson: any): Observable<any> {
    let sessid=JSON.parse(this.cookieService.getCookie("userInfo")).SESSION_ID;
    inputJson['SESSION_ID']=sessid;
    return this.http.post<any>(`${environment.api.uploadFile2}`, inputJson);
  }

  base64Encode(input: string): string {
    return btoa(encodeURIComponent(input).replace(/%([0-9A-F]{2})/g, function (match, p1) {
			return String.fromCharCode(parseInt('0x' + p1, 16));
		}));
  }
}
